import { Button, SvgRecord } from '@loomhq/lens';
import { setup } from '@loomhq/loom-sdk';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { addCommentCreator } from 'creators/commentsGraphQl';
import { videoPlayerShowComments } from 'creators/videoPlayer';
import { getAnonUserName } from 'utilities/auth';

import { CREATION_METHOD_RECORD_REPLY } from '../../../constants/comments';
import { LOOM_SDK_API_KEY } from '../../../constants/runtimeConfig';

export function RecordAReplyButton() {
  const dispatch = useDispatch();
  const ref = useRef(null);

  const [loom, setLoom] = useState(null);

  useEffect(() => {
    (async () => {
      if (loom === null) {
        const instance = await setup({ apiKey: LOOM_SDK_API_KEY });

        setLoom(instance);
      }
    })();
  }, [loom]);

  useLayoutEffect(() => {
    if (ref?.current && loom !== null) {
      loom.configureButton({
        element: ref.current,
        hooks: {
          onInsertClicked: oembed => {
            dispatch(
              addCommentCreator(
                oembed.sharedUrl, // Comment text - just the loom link
                null, // Not a reply to an existing comment
                getAnonUserName(),
                CREATION_METHOD_RECORD_REPLY
              )
            );

            dispatch(videoPlayerShowComments());
          },
          onAnalyticsEvent: event => {
            console.log(' event');
            console.log('analytics event provided', event);
          },
        },
      });
    }
  }, [loom, dispatch]);

  return (
    // neutral buttons are transparent - wrap it in a white background
    <div ref={ref} className="bgc:white radius:medium">
      <Button variant="neutral" icon={<SvgRecord color="#ff623e" />}>
        Record a Reply
      </Button>
    </div>
  );
}
